import supabase from "../supabaseClient";

// --- REPOSTS ---

// Fetch repost count for a post
export async function fetchRepostCount(postId) {
  const { count, error } = await supabase
    .from('post_reposts')
    .select('id', { count: 'exact', head: true })
    .eq('post_id', postId);
  if (error) throw error;
  return count;
}

// Add a repost for the current user
export async function addRepost(postId, userId) {
  const { data, error } = await supabase
    .from('post_reposts')
    .upsert([{ post_id: postId, user_id: userId }], { onConflict: ['post_id', 'user_id'] });
  if (error) throw error;
  return data;
}

// Remove a repost for the current user
export async function removeRepost(postId, userId) {
  const { error } = await supabase
    .from('post_reposts')
    .delete()
    .eq('post_id', postId)
    .eq('user_id', userId);
  if (error) throw error;
}

// --- SHARES ---

// Fetch share count for a post
export async function fetchShareCount(postId) {
  const { count, error } = await supabase
    .from('post_shares')
    .select('id', { count: 'exact', head: true })
    .eq('post_id', postId);
  if (error) throw error;
  return count;
}

// Add a share for the current user
export async function addShare(postId, userId, sharedTo = null) {
  const { data, error } = await supabase
    .from('post_shares')
    .insert([{ post_id: postId, user_id: userId, shared_to: sharedTo }]);
  if (error) throw error;
  return data;
}